import * as Yup from 'yup';

const registrationSchema = Yup.object().shape({
  customer: Yup.object().shape({
    firstName: Yup.string().required('Il nome è obbligatorio'),
    lastName: Yup.string().required('Il cognome è obbligatorio'),
    email: Yup.string()
      .email('Indirizzo email non valido')
      .required("L'email è obbligatoria"),
    password: Yup.string()
      .min(8, 'La password deve contenere almeno 8 caratteri')
      .required('La password è obbligatoria'),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Le password non corrispondono')
      .required('Conferma la password'),
    mobileNumber: Yup.string()
      .matches(/^[0-9]{10}$/, 'Formato numero di telefono non valido')
      .nullable(),
    notifiedBy: Yup.array()
      .of(Yup.string().oneOf(['email', 'sms']))
      .min(1, 'La preferenza di notifica è obbligatoria')
      .required('La preferenza di notifica è obbligatoria'),
    acceptedTerms: Yup.boolean()
      .equals([true], 'Devi accettare i termini e le condizioni')
      .required("L'accettazione dei termini è obbligatoria"),
  }),

  agency: Yup.object().shape({
    name: Yup.string().notRequired().nullable(),
    representative: Yup.string().notRequired().nullable(),
    companyTypeId: Yup.string().notRequired().nullable(),
    documentTypeId: Yup.number().nullable(),
    documentNumber: Yup.string()
      .nullable()
      .when('documentTypeId', {
        is: (documentTypeId: number) => documentTypeId != null,
        then: Yup.string().required('Numero del documento è obbligatorio'),
        otherwise: Yup.string().notRequired().nullable(),
      }),
    expiresAt: Yup.date()
      .nullable()
      .when('documentTypeId', {
        is: (documentTypeId: number) => documentTypeId != null,
        then: Yup.date()
          .min(new Date(new Date().setFullYear(new Date().getFullYear() - 5)))
          .max(new Date(new Date().setFullYear(new Date().getFullYear() + 5)))
          .required('Data di scadenza è obbligatoria'),
        otherwise: Yup.date().nullable().notRequired(),
      }),
    documents: Yup.mixed()
      .nullable()
      .when('documentTypeId', {
        is: (documentTypeId: number) => documentTypeId != null,
        then: Yup.mixed()
          .required('Il documento è obbligatorio')
          .test('file-required', 'Carica il documento necessario', (value) => {
            return value != null; // Ensure that there is a document
          }),
        otherwise: Yup.mixed().notRequired(),
      }),

    businessName: Yup.string().nullable(),
    firstName: Yup.string().when('businessName', {
      is: (businessName: string) => !businessName,
      then: (schema) =>
        schema.required(
          "Il nome è obbligatorio se il nome dell'azienda e il cognome sono vuoti"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    lastName: Yup.string().when('businessName', {
      is: (businessName: string) => !businessName,
      then: (schema) =>
        schema.required(
          "Il cognome è obbligatorio se il nome dell'azienda e il nome sono vuoti"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

    fiscalCode: Yup.string()
      .nullable()
      .notRequired()
      .test('fiscalCode-length', function(value) {
        if (!value || value.length === 0) {
          return true; // Allow empty values
        }
        if (value.length < 11) {
          return this.createError({
            message: 'Il codice fiscale deve contenere almeno 11 caratteri'
          });
        }
        if (value.length > 16) {
          return this.createError({
            message: 'Il codice fiscale deve contenere al massimo 16 caratteri'
          });
        }
        return true;
      }),
    vatNumber: Yup.string()
      .when('businessName', {
        is: (businessName: string | undefined) => !!businessName,
        then: (schema) =>
          schema.required(
            "Il numero di partita IVA è obbligatorio quando è fornito il nome dell'azienda"
          ),
      })
      .nullable(),

    address: Yup.string()
      .typeError("L'indirizzo è obbligatorio")
      .required("L'indirizzo è obbligatorio"),
    houseNumber: Yup.string()
      .typeError('Numero civico è obbligatorio')
      .required('Numero civico è obbligatorio'),
    postalCode: Yup.string()
      .typeError('Il codice postale è obbligatorio')
      .matches(/^\d{5}$/, 'Codice postale non valido')
      .required('Il codice postale è obbligatorio'),
    municipalityId: Yup.string()
      .typeError('La città è obbligatoria')
      .required('La città è obbligatoria'),
    province: Yup.string()
      .typeError('La provincia è obbligatoria')
      .required('La provincia è obbligatoria'),
    regionId: Yup.string()
      .typeError('Lo stato è obbligatorio')
      .required('Lo stato è obbligatorio'),
    streetId: Yup.string()
      .typeError('Il toponimo è obbligatorio')
      .required('Il toponimo è obbligatorio'),
    email: Yup.string()
      .typeError("L'email è obbligatoria")
      .email('Indirizzo email non valido')
      .required("L'email è obbligatoria"),
  }),
});

export default registrationSchema;
